import { ProjectConfig as IInboxConfig } from 'src/app/shared/classes/projects/project-config.class';
import { IConfig } from 'src/app/app.interfaces';

export class InboxConfig extends IInboxConfig {
  constructor(params: IConfig['extraConfig']) {
    super(params);
  }
}
